/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */
import {$Container, FC, $RichText} from '@gongxigames/framework/core/fragments/BuilderY';
import {Signal, Store} from '@gongxigames/framework/core';
import {CounterData} from '@gongxigames/framework/promotions';
import {$PopupBg} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Popup';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';

type UIKoalaPromotionCounterPops = {showCounter: Signal<boolean>; promotionCount: Signal<CounterData>; valuedAtEnabled: Signal<boolean>;};

export const $UIKoalaPromotionCounter: FC<UIKoalaPromotionCounterPops> = ({showCounter, promotionCount, valuedAtEnabled}) => {

    const frCountValues = Store.computed(() => {
        const {left, total} = promotionCount.value;

        return {left, total: total ?? 0};
    });

    const betValues = Store.computed(() => {
        const {bet} = promotionCount.value;

        return {bet: slotStore.currencyFormatter.value!.formatCents(bet!)};
    });

    const promotionTexts = Store.computed(() => {
        const {type, left, id, valuedAtEnabled} = promotionCount.value

        const counterWith4Rows = id && valuedAtEnabled;
        const titlesTextLastRounds = type === 'free-round' ? 'lastFreeRound' : 'lastAwardedFeature';
        const titlesTextOtherRounds = type === 'free-round' ? 'relaxFreeRoundsCounterTitle' : 'awardedFeatureCounterTitle';
        const titlesText = left === 0 ? titlesTextLastRounds : titlesTextOtherRounds;

        const valuedAtText = counterWith4Rows
            ? 'relaxFreeRoundsBetRichText4Rows'
            : left === 0
            ? 'relaxFreeRoundsBetRichText4Rows'
            : 'relaxFreeRoundsBetRichText';

        return {titlesText, valuedAtText};
    });

    const PORTRAIT_POSITION: ResponsiveConf = {
        updateHeight: true,
        updateWidth: true,
        box: {x: '0%', y: '100%', width: '240px', height: '260px'},
        translate: {x: '30px', y: '-470px'}
    };

    const LANDSCAPE_POSITION: ResponsiveConf = {
        updateHeight: true,
        updateWidth: true,
        box: {x: '0%', y: '100%', width: '240px', height: '260px'},
        translate: {x: '30px', y: '-590px'}
    };

    const responsive = Store.computed(() => slotStore.stage_isPortrait.value ? PORTRAIT_POSITION : LANDSCAPE_POSITION);

    return <$Container name='portrait'>
        <$PopupBg
            responsive={responsive}
            visible={showCounter}
        >
            
            <$RichText style={{fill: 0xFFC000, fontFamily: 'Exo DemiBold', wordWrap: true, wordWrapWidth: 220, fontSize: 38, align: 'center'}}
                responsive={{
                    box: {x: '50%', y: '40px'},
                }}
                visible={Store.computed(() => frCountValues.value.left === 0)}
                localeID={Store.computed(() => promotionTexts.value.titlesText)} />

            <$RichText style={{fill: 0xFFFFFF, fontFamily: 'Exo DemiBold', wordWrap: true, wordWrapWidth: 220, fontSize: 32, align: 'center'}}
                responsive={{
                    box: {x: '50%', y: '20px'},
                }}
                visible={Store.computed(() => frCountValues.value.left > 0)}
                localeID={Store.computed(() => promotionTexts.value.titlesText)} />

            <$RichText style={{fill: 0xFFAE00, fontFamily: 'Exo Bold', fontSize: 54, align: 'center'}}
                responsive={{
                    box: {x: '50%', y: '100px'},
                }}
                localeID='freeGamesCounterLeftAmountRichText'
                visible={Store.computed(() => frCountValues.value.left > 0)}
                values={frCountValues}/>

            <$RichText style={{fill: 0xFFFFFF, fontFamily: 'Exo DemiBold', wordWrap: true, wordWrapWidth: 220, fontSize: 32, align: 'center'}}
                responsive={{
                    box: {x: '50%', y: '164px'},
                }}
                values={betValues}
                visible={Store.computed(() => Boolean(promotionCount.value.bet) && valuedAtEnabled.value)}
                localeID={Store.computed(() => promotionTexts.value.valuedAtText)}/>

            <$RichText style={{fill: 0xFFFFFF, fontFamily: 'Exo DemiBold', wordWrap: true, wordWrapWidth: 220, fontSize: 26, align: 'center'}}
                responsive={{
                    box: {x: '50%', y: '186px'},
                }}
                values={Store.computed(() => ({id: promotionCount.value.id!}))}
                visible={Store.computed(() => Boolean(promotionCount.value.id))}
                localeID='freeRoundVoucher'/>
        </$PopupBg>
    </$Container>;
};